var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardTt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8975 13.2419L16.16 20.3469C16.1741 20.4306 16.1624 20.5166 16.1263 20.5934C16.0903 20.6702 16.0316 20.7342 15.9583 20.7768C15.8849 20.8194 15.8002 20.8385 15.7156 20.8317C15.6311 20.8249 15.5506 20.7924 15.485 20.7386L12.5016 18.4994C12.3576 18.3918 12.1827 18.3337 12.0029 18.3337C11.8231 18.3337 11.6482 18.3918 11.5041 18.4994L8.51581 20.7378C8.45024 20.7915 8.36986 20.8239 8.28539 20.8307C8.20092 20.8376 8.11637 20.8185 8.04303 20.776C7.96969 20.7335 7.91104 20.6697 7.87491 20.5931C7.83878 20.5164 7.82688 20.4305 7.84081 20.3469L9.10248 13.2419",
    stroke: "#6860EE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.167C14.7614 14.167 17 11.9284 17 9.16699C17 6.40557 14.7614 4.16699 12 4.16699C9.23858 4.16699 7 6.40557 7 9.16699C7 11.9284 9.23858 14.167 12 14.167Z",
    stroke: "#6860EE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTt);
export default __webpack_public_path__ + "static/media/dashboard-tt.8fdcf0baa98fd510a0b21b244909becf.svg";
export { ForwardRef as ReactComponent };